<template>
	<div>
		<el-form label-width="560px">
			<el-form-item label="是否开启抽奖活动">
				<el-radio-group v-model="is_prize">
					<el-radio :label="1">是</el-radio>
					<el-radio :label="0">否</el-radio>
				</el-radio-group>
			</el-form-item>
		</el-form>
		<div v-if="is_prize == 1">
			<el-table :data="luckData" style="width: 70%;margin: 0 auto;" ref="table" empty-text="暂无进行中/未开始活动">
				<el-table-column label="选择活动ID" align="center" width="120">
					<template slot-scope="scope">
						<el-radio
							:label="scope.row.id"
							v-model="prize_id"
							@change.native="handleSelectionChange(scope.row)"
							>&nbsp;</el-radio
						>
					</template>
				</el-table-column>
				<el-table-column prop="prize_name" label="活动标题"> </el-table-column>
				<el-table-column prop="start_time" label="开始时间"> </el-table-column>
				<el-table-column prop="end_time" label="结束时间"> </el-table-column>
				<el-table-column prop="luck_status" label="活动状态">
					<template slot-scope="scope">
						<el-tag
							:type="
								scope.row.luck_status == 0
									? 'success'
									: scope.row.luck_status == 1
									? 'info'
									: 'danger'
							"
							v-text="
								scope.row.luck_status == 0
									? '进行中'
									: scope.row.luck_status == 1
									? '未开始'
									: '已结束'
							"
						></el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="slogan" label="活动标语"> </el-table-column>
				<el-table-column prop="slogan" label="活动皮肤">
					<template slot-scope="scope">
						<img
							style="width: 50px;height: 60px;"
							:src="scope.row.pic_url"
							alt=""
						/>
					</template>
				</el-table-column>
				<el-table-column prop="slogan" label="开启/关闭">
					<template slot-scope="scope">
						<el-tag
							:type="scope.row.status == 1 ? 'success' : 'danger'"
							v-text="scope.row.status == 1 ? '启用' : '禁用'"
						></el-tag>
					</template>
				</el-table-column>
			</el-table>
<!--			<el-pagination-->
<!--				style="margin: 20px auto;width: 70%;"-->
<!--				background-->
<!--				layout="prev, pager, next"-->
<!--				:total="total"-->
<!--				@current-change="currentChange"-->
<!--			>-->
<!--			</el-pagination>-->
		</div>
	</div>
</template>
<script>
import { luck_Data } from "@/api/vip";
import time from "@/utils/time";
import store from "@/store/index";

export default {
	data() {
		return {
			luckData: [],
			total: 0,
			page: 1,
			select: [],
			is_prize: 0,
			prize_id: "",
			radio: "",
		};
	},
	mounted() {
		this.init();
	},
	methods: {
		//初始化
		init() {
			this.get_luck_Data();
		},
		//分页
		currentChange(val) {
			this.page = val;
			this.get_luck_Data();
		},
		//获取抽奖列表
		async get_luck_Data() {
			try {
				const res = await luck_Data({
					app_id: store.getters.app_id,
				});
				if (res.code == 200) {
					let arr = [];
					res.data.forEach((item, i) => {
						if (time.isDuringDate(item.start_time, item.end_time) == 0) {
							item.luck_status = 0;
						} else if (time.isDuringDate(item.start_time, item.end_time) == 1) {
							item.luck_status = 1;
						} else {
							item.luck_status = 2;
						}
						if (item.status == 1) {
							arr.push(item);
						}
					});
					this.luckData = arr;
				}
			} catch (e) {
				console.log(e);
			}
		},
		//默选(回显)
		echo() {
			this.luckData.forEach((item, i) => {});
		},
		//多选
		handleSelectionChange(val) {
			console.log("val", val);
			// val.forEach((item, i) => {
			// 	val[i] = item.id;
			// });
			// this.select = val;
		},
	},
};
</script>
